import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It is `}<strong parentName="p">{`ok`}</strong>{` for your `}<strong parentName="p">{`project API key`}</strong>{` (starts with `}<inlineCode parentName="p">{`phc_`}</inlineCode>{`) to be public. It is used to initialize PostHog, capture events, evaluate feature flags, and more, but doesn't have access to your private data.`}</p>
    <p>{`It is `}<strong parentName="p">{`not recommended`}</strong>{` for your `}<strong parentName="p">{`personal API key`}</strong>{` (starts with `}<inlineCode parentName="p">{`phx_`}</inlineCode>{`) to be public as it enables reading and writing potentially private data.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      